import { formatClock, formatDate } from '$func/time'
import { t } from '$i18n'
import { isRecentDate } from '$func/date'

export function lastSeenAt(time: number | string) {
  const date = new Date(time)

  const { isToday, isYesterday } = isRecentDate(date)

  return isToday
    ? `${t('user.status.lastSeenAt')} ${formatClock(date)}`
    : isYesterday
    ? `${t('user.status.lastSeenYesterday')} ${formatClock(date)}`
    : `${t('user.status.lastSeenAt')} ${formatDate(date)}`
}
